import { openAiClientForJql } from "../../../jira/ai/ai.client.for.jql";
import { aiClassifier } from "../prompts/ai.query.prompt";
import { Message } from "../ai.types";
import { aiConfig } from "../../..";
import { jiraKeywords } from "../../../jira/jira.postprocessing";
import { checkIfWindows } from "@me8eon/browser";
import { EnvironmentConfig } from "@me8eon/config";

const containsJiraKeyword = (prompt: string) =>
    jiraKeywords.some((kw) => prompt.toLowerCase().includes(kw.toLowerCase()));

const aiPromptClassifier = async (prompt: string, featureFlagEnabled?: boolean) => {
    if (prompt.toLowerCase().includes("show")) {
        if (prompt.toLowerCase().includes("incidents") || prompt.toLowerCase().includes("orders")) {
            return { classificationResult: "action", translated_query: prompt };
        }
    }
    const aiPrompt = `${aiClassifier}
    Input: "${prompt}"
    Output:`;
    const messages: Message[] = [
        { role: "system", content: aiPrompt },
        { role: "user", content: prompt },
    ];

    const jqlAiClient = openAiClientForJql(aiConfig);
    const outputMessages = await jqlAiClient(messages);
    const gptResponseObj = outputMessages?.[outputMessages.length - 1]?.content?.trim();

    const cleanJsonFromCodeFence = (text: string): string => {
        return text
            .replace(/```json\s*/gi, '') // remove ```json
            .replace(/```/g, '')         // remove closing ```
            .trim();
    };
    const cleanedJSON = JSON.parse(cleanJsonFromCodeFence(gptResponseObj || "{}"));
    const gptResponse = cleanedJSON?.["category"];

    const enableJQLIntegration = window.location.href.includes("jql=true");

    const translated_query = cleanedJSON?.translated_query || prompt;

    if (enableJQLIntegration) {
        if (gptResponse?.toLowerCase() === "jira" || containsJiraKeyword(prompt)) {
            return { classificationResult: "jira", translated_query };
        }
    }
    if (gptResponse?.toLowerCase() === "nextthink" && checkIfWindows()) {
        return { classificationResult: "nextthink", translated_query };
    }

    if (gptResponse?.toLowerCase() === "teams" && checkIfWindows()) {
        return { classificationResult: "teams", translated_query };
    }

    return {
        classificationResult: "rag",
        translated_query,
        original_query: prompt, 
    }
};

export default aiPromptClassifier;